export class Effect {
    public done: boolean = false;
    constructor(
        public position: [number, number],
        public target: [number, number],
        public direction: [number, number],
        public speed: number = 1,
        public damage: number = 2,
        public area_of_effect: number = 0.75,
    ) {

    }
}